import { ColDef } from 'ag-grid-community';
import { currencyFormatter } from 'src/util/grid/cellFormatter';

import { formatMonthHeader } from '../../utils';

/**
 * Creates dynamic column definitions for royalties pivot view
 * Territory, Vendor, then dynamic month columns
 */
export const createRoyaltiesPivotColDefs = (availableMonths: string[]): ColDef[] => {
    const baseColumns: ColDef[] = [
        {
            field: 'vendor',
            headerName: 'Vendor',
            flex: 2,
            minWidth: 180,
            sortable: true,
            rowGroup: true,
            hide: true
        }
    ];

    // Create dynamic month columns
    const monthColumns: ColDef[] = availableMonths.map((month) => ({
        field: month,
        headerName: formatMonthHeader(month),
        filter: 'agNumberColumnFilter',
        flex: 1,
        minWidth: 120,
        sortable: true,
        valueFormatter: currencyFormatter,
        valueGetter: (params) => {
            // Handle missing data gracefully
            const value = params.data?.[month];
            return value != null ? value : 0;
        },
        aggFunc: 'sum'
    }));

    return [...baseColumns, ...monthColumns];
};

/**
 * Static column definitions for when no data is available
 */
export const royaltiesPivotColDefsEmpty: ColDef[] = [
    {
        field: 'territory',
        headerName: 'Territory',
        filter: 'agSetColumnFilter',
        flex: 1,
        minWidth: 120,
        sortable: true
    },
    {
        field: 'vendor',
        headerName: 'Vendor',
        filter: 'agSetColumnFilter',
        flex: 2,
        minWidth: 180,
        sortable: true
    }
];
